/* Orelle category pages: a colour dot swaps its card to that colour's two
   photographs and points the card's links at that colour. */
(function () {
  function swap(img, src, srcset) {
    if (!img || !src) return;
    img.removeAttribute('srcset');
    if (srcset) img.setAttribute('srcset', srcset);
    img.src = src;
  }

  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-o2col-dot]');
    if (!dot) return;
    var card = dot.closest('.o2col__card');
    if (!card) return;

    card.querySelectorAll('[data-o2col-dot]').forEach(function (d) {
      var on = d === dot;
      d.classList.toggle('is-on', on);
      d.setAttribute('aria-pressed', String(on));
    });

    var media = card.querySelector('.o2col__media');
    swap(card.querySelector('[data-o2col-img]'), dot.dataset.src, dot.dataset.srcset);
    var hover = card.querySelector('[data-o2col-img2]');
    if (dot.dataset.src2) {
      swap(hover, dot.dataset.src2, dot.dataset.srcset2);
      if (media) media.classList.toggle('has-hover', !!hover);
    } else if (media) {
      media.classList.remove('has-hover');
    }

    if (dot.dataset.url) {
      card.querySelectorAll('[data-o2col-link]').forEach(function (a) { a.href = dot.dataset.url; });
    }
  });
})();
